/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin gibt es in mehreren Sprachen`
};

const en_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin is available in several languages`
};

const es_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin está disponible en varios idiomas`
};

const fr_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin existe en plusieurs langues`
};

const it_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin è disponibile in diverse lingue`
};

const nl_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `ViaMichelin is beschikbaar in verschillende talen`
};

const pt_modal__locale_switch_title = /** @type {(inputs: {}) => string} */ () => {
	return `O ViaMichelin está disponível em várias línguas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.modal__locale_switch_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("modal__locale_switch_title", locale)
	if (locale === "de") return de_modal__locale_switch_title(inputs)
	if (locale === "en") return en_modal__locale_switch_title(inputs)
	if (locale === "es") return es_modal__locale_switch_title(inputs)
	if (locale === "fr") return fr_modal__locale_switch_title(inputs)
	if (locale === "it") return it_modal__locale_switch_title(inputs)
	if (locale === "nl") return nl_modal__locale_switch_title(inputs)
	return pt_modal__locale_switch_title(inputs)
};